export default {
	FREE: 'free',
	FIXED: 'fixed',
	toString: (value) => {
		switch (value) {
			case 'free':
				return '시/분 자유 선택';
			case 'fixed':
				return '지정된 항목만 선택하도록 제한';
			default:
				return '-';
		}
	},
};
